<template>
  <div class="h-full">
    <Swiper :modules="modules" :pagination="true" :slides-per-view="1" class="h-full">
      <SwiperSlide>
        <p class="guide-text my-4">
          The <span class="font-bold">Unit Page</span> gives you detailed <span class="font-bold">visibility</span> into
          the <span class="font-bold">health</span> and <span class="font-bold">configuration</span> of individual
          <span class="font-bold">Metering</span> and <span class="font-bold">Leak Monitoring</span> devices.
        </p>
        <img class="guide-img" src="@/assets/guides/unit/welcome.webp" />
        <p class="guide-text mt-4">
          This page also provides <span class="font-bold">simple</span> tools to
          <span class="font-bold">program</span> and <span class="font-bold">configure</span> new unit equipment.
        </p>
      </SwiperSlide>
      <SwiperSlide>
        <img class="guide-img mt-6" src="@/assets/guides/unit/location-form-1.webp" />
        <p class="guide-text my-4">
          Use the <span class="font-bold">Location Form</span> to update the
          <span class="font-bold">contextual information</span> of a unit.
        </p>
        <img class="guide-img mt-4 mb-2" src="@/assets/guides/unit/location-form-2.webp" />
        <p class="guide-text">
          After editing the <span class="font-bold">Name</span>, <span class="font-bold">Building</span>, or
          <span class="font-bold">Description</span>, "Cancel" and "Save" buttons will appear under the form. Remember
          to tap "<span class="font-bold">Save</span>" to apply your changes!
        </p>
      </SwiperSlide>
      <SwiperSlide>
        <p class="guide-text mt-4">
          While viewing a particular meter, look for an overall <span class="font-bold">health status.</span>
        </p>
        <img class="guide-img" src="@/assets/guides/unit/meter-section-1.webp" />
        <p class="guide-text">
          "<i class="icon-check text-green-500"></i>" gives you the <span class="font-bold">confidence</span> that this
          installation looks good.
        </p>
        <img class="guide-img" src="@/assets/guides/unit/meter-section-2.webp" />
        <p class="guide-text">
          "<i class="icon-x text-red-500"></i>" indicates something is <span class="font-bold">wrong</span> that
          <span class="font-bold">requires attention.</span>
        </p>
        <img class="guide-img" src="@/assets/guides/unit/meter-section-3.webp" />
        <p class="guide-text">
          At the bottom of a meter's detail section, you can find additional
          <span class="font-bold">health information</span> about the <span class="font-bold">connected device.</span>
        </p>
      </SwiperSlide>
      <SwiperSlide>
        <img class="guide-img mt-4" src="@/assets/guides/unit/configure-meter-1.webp" />
        <p class="guide-text">
          Tap the <span class="font-bold">configuration</span> button to view/edit the meter's
          <span class="font-bold">model, signal type, multiplier, IMR</span>, and more.
        </p>
        <img class="guide-img" src="@/assets/guides/unit/configure-meter-2.webp" />
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<script setup lang="ts">
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/pagination';

const modules = [Pagination];
</script>

<style scoped>
.guide-img {
  @apply w-full max-w-[300px] md:max-w-[350px] mx-auto;
}
.guide-text {
  @apply w-[300px] max-w-[75%] mx-auto text-center text-gray-700 font-normal text-sm md:text-base;
}
</style>
